import { render } from "./ViolinRange.vue?vue&type=template&id=7012f008&scoped=true"
import script from "./ViolinRange.vue?vue&type=script&lang=js"
export * from "./ViolinRange.vue?vue&type=script&lang=js"

import "./ViolinRange.vue?vue&type=style&index=0&id=7012f008&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7012f008"]])

export default __exports__